(function () {
  let nextBtn = document.querySelector('.toolkits-page .js-next-btn');

  console.log(nextBtn);

  if (nextBtn) {
    nextBtn.addEventListener('click', function (event) {
      //check if switching toolkit and update the content
      const cap_toolkit = document.querySelector(
        'input[type="hidden"][name="cap_toolkit"]'
      );
      const new_toolkit = document.querySelector(
        'input[type="radio"][name="original_toolkit"]:checked'
      );

      const redirectUrl = document.querySelector(
        'input[type="hidden"][name="submit_redirect"]'
      );
      if (redirectUrl) {
        //update the value to this link
        redirectUrl.value = nextBtn.getAttribute('data-url', '');
      }

      const modal = document.querySelector('.accessible-modal-breadcrumbs');
      if (cap_toolkit && new_toolkit && modal) {
        if (cap_toolkit.value != new_toolkit.value) {
          event.preventDefault();
          const h4 = modal.querySelector('.heading-save');
          h4.textContent = 'Switching Toolkits?';
          const content = modal.querySelector('.accessible-modal__content');
          content.innerHTML =
            "<p>Switching Toolkits will clear any content added to the 'Steps' and 'Evaluation' sections. These sections will update with the new Toolkit's content to fill in. </p><p>Click " +
            '"Update Toolkit"' +
            ' to continue with selecting a new Toolkit, or ' +
            '"Cancel"' +
            ' to go back to.</p>';
          const discardBtn = modal.querySelector(
            '.js-accessible-modal-discard'
          );

          discardBtn.addEventListener('click', function (event) {
            window.location.href = this.getAttribute('data-url', '');
          });

          discardBtn.textContent = 'Cancel';
          const discardBtn2 = modal.querySelector('.btn-primary');
          discardBtn2.textContent = 'Update Toolkit';
        } else {
          document.getElementById('modalOverlay').style.display = 'none';
          modal.style.display = 'none';
        }
      }
    });
  }
})();
